const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-add-circle{fill:#707070;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.375 -3.375)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-add-circle",
  d: "M21.976,15.778H17.64V11.443a.931.931,0,0,0-1.862,0v4.335H11.443a.892.892,0,0,0-.931.931.9.9,0,0,0,.931.931h4.335v4.335a.9.9,0,0,0,.931.931.926.926,0,0,0,.931-.931V17.64h4.335a.931.931,0,0,0,0-1.862Z",
  transform: "translate(-1.23 -1.23)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-add-circle",
  d: "M15.479,5A10.471,10.471,0,1,1,8.071,8.071,10.406,10.406,0,0,1,15.479,5m0-1.629a12.1,12.1,0,1,0,12.1,12.1,12.1,12.1,0,0,0-12.1-12.1Z"
}));
function SvgIconionicIosAddCircleOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.208,
    height: 24.208,
    viewBox: "0 0 24.208 24.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosAddCircleOutline);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-add-circle-outline.f00a6db9.svg";
export { ForwardRef as ReactComponent };